import { render } from "./SectionWelcome.vue?vue&type=template&id=4c508421&scoped=true"
import script from "./SectionWelcome.vue?vue&type=script&lang=js"
export * from "./SectionWelcome.vue?vue&type=script&lang=js"

import "./SectionWelcome.vue?vue&type=style&index=0&id=4c508421&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c508421"]])

export default __exports__